import { React, useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { rootRoute } from "../../config";
import { errorMsg } from "../../helper/helpers";
import { init_simulation, startover_simulation } from "./services/api";
import Header from "../common/Header";
import Footer from "../common/Footer";
import Error from "../common/Error";
import QmModuleStyle from './styles/qm.module.css';
import { getSession, setSession } from "../../App";

// import "./styles/App.css";
const App = () => {
  const [sessionid, setSessionId] = useState("");
  const [simObj, setSimObj] = useState({});
  const [toggleSimulation, setToggleSimulation] = useState(false);
  const [isOverlay, setIsOverlay] = useState(true);
  const [simPopup, setSimPopup] = useState(false);
  const [headerPopup, setHeaderPopup] = useState(true);
  const [plPopup, setPlPopup] = useState(false);
  const [ulPopup, setUlPopup] = useState(false);
  const [accordionPopup, setAccordionPopup] = useState(false);
  const [simPrgPopup, setSimPrgPopup] = useState(false);
  const [isArtifacts, setIsArtifacts] = useState(true);
  const [isPopupShown, setIsPopupShown] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [isPopupOverlay, setIsPopupOverlay] = useState(false);
  const [isExitPopup, setIsExitPopup] = useState(false);
  const [error, setError] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qmPopup, setQmPopup] = useState({
    availableCash: false,
    utilizeBtn: false,
    utilizedInvest: false,
    makeInvetsment: false,
    pauseSimulation: false,
    kpiBox: false,
  });
  const [relaunchPopup, setRelaunchPopup] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let pathname = window.location.pathname;
  let simType =
    pathname.indexOf("/im") !== -1 || pathname.indexOf("/IM") !== -1
      ? "im"
      : pathname.indexOf("/fc") !== -1 || pathname.indexOf("/FC") !== -1
      ? "fc"
      : pathname.indexOf("/pm") !== -1 || pathname.indexOf("/PM") !== -1
      ? "pm"
      : pathname.indexOf("/qm") !== -1 || pathname.indexOf("/QM") !== -1
      ? "qm"
      : pathname.indexOf("/scm") !== -1 || pathname.indexOf("/SCM") !== -1
      ? "scm"
      : "";
  const getMonth = (number) => {
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[number - 1];
  };
  const setAriaProperty = (value) => {
    let elements = document.querySelectorAll("*");
    elements.forEach(function (element) {
      if (window.$(element).closest(".ui.pointing").length == 0) {
        element.setAttribute("aria-hidden", value);
      }
    });
  };
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter(
      (artifact) => artifact.readstatus == 1
    ).length;
    return (
      simObj?.currentstep > 0 ||
      simObj?.attemptno > 1 ||
      readStatusLength > 0 ||
      (simObj?.decisionHistory != null &&
        simObj?.decisionHistory?.length != undefined &&
        simObj?.decisionHistory?.length != 0)
    );
  };
  const check_Location = () => {
    setToggleSimulation(false);
    if (
      getSession() != null &&
      typeof simObj?.sessionid != "undefined"
    ) {
      let queryParams = new URLSearchParams(location.search);
      if (queryParams.has("from") && queryParams.get("from") == "simulation") {
        navigate(`${rootRoute}/${simType.toLowerCase()}?from=simulation`);
      } else {
        if (fuSkipWalkThruPopups()) {
          navigate(`${rootRoute}/qm/simulation`);
        }
      }
    }
  };
  const skipWalkThruPopups = () => {
    if (document.querySelector(".help-link") != null && isOverlay) {
      document.querySelector(".help-link").focus();
    }
    setHeaderPopup(false);
    setSimPopup(false);
    setPlPopup(false);
    setUlPopup(false);
    setSimPrgPopup(false);
    setAccordionPopup(false);
    setIsOverlay(false);
    setIsPopupShown(true);
    setQmPopup({
      availableCash: false,
      utilizeBtn: false,
      utilizedInvest: false,
      makeInvetsment: false,
      pauseSimulation: false,
      kpiBox: false,
    });
  };
  const startOverSimulation = () => {
    if(!(window.location.href.includes("/settings")) && !(window.location.href.toLowerCase().includes("/prework")) && !(window.location.href.toLowerCase().includes("/reflection"))){
    if (
      document.querySelector("#details") != null ||
      document.querySelector("#progressed-goal") != null
    ) {
      document.querySelector("#details").setAttribute("tabindex", "0");
      // document.querySelector("#progressed-goal").setAttribute("tabindex","0");
    }
    setIsLoader(true);
    startover_simulation(sessionid)
      .then(function (response) {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{

        if (sessionid != "") {
          init_simulation(sessionid)
            .then(function (response) {
              if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                setError(response?.data)
            }
            else{
              //console.log(response.data);
              setSimObj(response?.data);
              setToggleSimulation(false);
            }
            })
            .catch((error) => {
              // setError(errorMsg);
              if(typeof error == "object" && error.hasOwnProperty("data") && typeof error.data == "object" && error.data.hasOwnProperty("id") && error.data.hasOwnProperty("msg")){
                setError(error.data)
              }else{
                setError({"id":"00000","msg":errorMsg})
              }
              console.log(error);
            });
        }
        simObj.currentstep > 0 && skipWalkThruPopups();
      }
      })
      .catch((error) => {
        // setError(errorMsg);
        if(typeof error == "object" && error.hasOwnProperty("data") && typeof error.data == "object" && error.data.hasOwnProperty("id") && error.data.hasOwnProperty("msg")){
          setError(error.data)
        }else{
          setError({"id":"00000","msg":errorMsg})
        }
        console.log(error);
      });

      // Trigger the reset user data input event
      triggerResetUserDataInput();
      navigate(rootRoute + "/qm");
    }
  };
  // Function to trigger the reset event
  function triggerResetUserDataInput() {
    const event = new Event('resetUserDataInput');
    document.dispatchEvent(event);
  }
  const initApp = () => {
    let localsid =
      getSession() != null
        ? getSession()
        : "";
    let sessionId;
    sessionId =
      window.location.hash != "" && queryParams.get("sid") == undefined
        ? window.location.hash != "" &&
          window.location.hash.split("#")[1].length > 20
          ? window.location.hash.split("#")[1]
          : localsid
        : queryParams.get("sid") != undefined
        ? queryParams.get("sid")
        : localsid;
    if (sessionId != "" && sessionid != sessionId) {
      setSession(sessionId);
      setSessionId(sessionId);
    }

    sessionId.length <= 0 && setError({"id":"00000","msg":errorMsg})
    window.location.hash = "";

    if (sessionid != "" && queryParams.get("sid") == undefined && !(window.location.href.includes("/settings")) && !(window.location.href.toLowerCase().includes("/prework")) && !(window.location.href.toLowerCase().includes("/reflection"))) {
      //setError(null);
      init_simulation(sessionid)
        .then(function (response) {
          // console.log(response.data);
          if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
            setError(response?.data)
        }
        else{
          setSimObj(
            Object.assign(response?.data, {
              simulationdetails: simObj?.simulationdetails,
            })
          );
          check_Location();
          setError(null);
        }
        })
        .catch((error) => {
          // setError(errorMsg);
          if(typeof error == "object" && error.hasOwnProperty("data") && typeof error.data == "object" && error.data.hasOwnProperty("id") && error.data.hasOwnProperty("msg")){
            setError(error.data)
          }else{
            setError({"id":"00000","msg":errorMsg})
          }
        });
    }
  };
  const focusPopUp = (selector=".ui.pointing:visible") => {
    const pointingLabels = Array.from(window.$(selector));
    pointingLabels.forEach((item) => {
      item.addEventListener("keydown", function (event) {
        const focusableElements = item.querySelectorAll(
          'h3,a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (event.key === "Tab") {
          if (event.shiftKey) {
            if (document.activeElement === focusableElements[0]) {
              event.preventDefault();
              focusableElements[focusableElements.length - 1].focus();
            }
          } else {
            if (
              document.activeElement ===
              focusableElements[focusableElements.length - 1]
            ) {
              event.preventDefault();
              focusableElements[0].focus();
            }
          }
        }
      });
    });
    var mainDiv = document.querySelector(".main");
    var focusableElementsMain = mainDiv.querySelectorAll(
      "a[href], button, input, select, textarea"
    );

    var footerDiv = document.querySelector("footer.footer");
    var focusableElementsFooter = footerDiv.querySelectorAll(
      "a[href], button, input, select, textarea"
    );

    var headerDiv = document.querySelector("header.header");
    var focusableElementsHeader = headerDiv.querySelectorAll(
      "a[href], button, input, select, textarea"
    );

    var focusableElementsApp = document.querySelectorAll(
      ".skip-to-main-content-link"
    );

    var tabFocusable = document.querySelectorAll(
      '[tabindex]:not([tabindex="-1"]'
    );
    var tabNotFocusable = document.querySelectorAll('[tabindex="-1"]');
    var tabFocusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"]');
    var allFocusableElements = [
      ...focusableElementsMain,
      ...focusableElementsFooter,
      ...focusableElementsHeader,
      ...focusableElementsApp,
    ];
    if (pointingLabels.length > 0) {
      allFocusableElements.forEach(function (element) {
        if (window.$(element).closest(selector).length == 0) {
          element.setAttribute("tabindex", "-1");
        }
      });
      tabFocusable.forEach(function (element) {
        if (window.$(element).closest(selector).length == 0) {
          element.setAttribute("tabindex", "-1");
        }
      });

      document
        .querySelector(".skip-to-main-content-link")
        .setAttribute("aria-hidden", "true");
    } else {
      allFocusableElements.forEach(function (element) {
        element.removeAttribute("tabindex");
      });
      tabFocusable.forEach(function (element) {
        element.setAttribute("tabindex", "0");
      });
      if (document.getElementsByClassName(`${QmModuleStyle['navigation-tab']}`).length) {
        if(document.getElementsByClassName(`${QmModuleStyle['navigation-tab']}`)[0].querySelectorAll("ul li a")){
          document.getElementsByClassName(`${QmModuleStyle['navigation-tab']}`)[0].querySelectorAll("ul li a").forEach(element => {
            element.setAttribute('tabindex', '-1');
        });
        }
      }
      // tabNotFocusable.forEach(function (element) {
      //   if(window.$(element).closest(".ui.pointing").length == 0){
      //     element.setAttribute('tabindex', '-1');
      //   }
      // });
      /* commented for keyboard navigation infoIcon
      if (
        document.querySelector("#details") != null ||
        document.querySelector("#progressed-goal") != null
      ) {
        document.querySelector("#details").setAttribute("tabindex", "0");
        // document.querySelector("#progressed-goal").setAttribute("tabindex","0");
      }*/
      if (document.querySelectorAll("#decisionMain button") != null) {
        document.querySelectorAll("#decisionMain button").forEach((element) => {
          if (element.getAttribute("aria-selected") === "false") {
            element.setAttribute("tabindex", "-1");
          }
        });
      }
      document
        .querySelector(".skip-to-main-content-link")
        .setAttribute("aria-hidden", "false");
      if (document.querySelectorAll(".Graphs button") != null) {
        const elementsWithClassGraphs =
          document.querySelectorAll(".Graphs button");
        elementsWithClassGraphs.forEach((element) => {
          if (element.getAttribute("aria-selected") === "false") {
            element.setAttribute("tabindex", "-1");
          }
        });
      }
    }
  };
  useEffect(() => {
    simObj.currentstep > 0 && skipWalkThruPopups();
    queryParams.get("sid") == undefined &&
      window.location.href.indexOf("/summary") == -1 &&
      (simObj?.currentstep > 0 || simObj?.currentstep == 0) &&
      setIsLoader(false);
  }, [simObj]);

  useEffect(() => {
    initApp();
    focusPopUp();
  }, [sessionid]);

  useEffect(() => {
    focusPopUp();
    document.querySelector(".ui.pointing") &&
      document.querySelector(".ui.pointing").focus();
  }, [
    plPopup,
    ulPopup,
    simPrgPopup,
    headerPopup,
    simPopup,
    isExitPopup,
    isOverlay,
    qmPopup,
  ]);

  return (
    <>
      <Header
        headerState={[
          isOverlay,
          setIsOverlay,
          simPopup,
          setSimPopup,
          headerPopup,
          setHeaderPopup,
          isArtifacts,
          ulPopup,
          setUlPopup,
          plPopup,
          setPlPopup,
          skipWalkThruPopups,
          simObj,
          setSimObj,
          getMonth,
          toggleSimulation,
          setToggleSimulation,
          isPopupOverlay,
          setIsPopupOverlay,
          setError,
          simType,
          false,
          ()=>{},
          qmPopup,
          setQmPopup,
          false,
          ()=>{},
          false,
          ()=>{},
          relaunchPopup,
          setRelaunchPopup
        ]}
      />
      <main className="main" aria-hidden={isPopupOverlay}>
        <div className="app qm">
          <Outlet
            context={[
              simPopup,
              setSimPopup,
              isOverlay,
              setIsOverlay,
              headerPopup,
              setHeaderPopup,
              isArtifacts,
              setIsArtifacts,
              plPopup,
              setPlPopup,
              ulPopup,
              setUlPopup,
              simPrgPopup,
              setSimPrgPopup,
              skipWalkThruPopups,
              isPopupShown,
              setIsPopupShown,
              accordionPopup,
              setAccordionPopup,
              simObj,
              setSimObj,
              getMonth,
              toggleSimulation,
              setToggleSimulation,
              startOverSimulation,
              isLoader,
              setIsLoader,
              setAriaProperty,
              check_Location,
              setError,
              error,
              simType,
              qmPopup,
              setQmPopup,
              setRelaunchPopup,
              focusPopUp,
              isModalVisible, 
              setIsModalVisible
            ]}
          ></Outlet>
        </div>
      </main>
      <Footer
        setIsOverlay={setIsOverlay}
        setToggleSimulation={setToggleSimulation}
        isExitPopup={isExitPopup}
        setIsExitPopup={setIsExitPopup}
        isOverlay={isOverlay}
        isPopupOverlay={isPopupOverlay}
        simType={simType}
      />
      {error != null && <Error error={error} setError={setError} />}
      {isOverlay || isPopupOverlay ? <div id="overlay"></div> : ""}
      {isModalVisible || isLoader || error != null ? (
        <div className="ui segment my-loader my-dimmer">
          <div className="ui active dimmer">
            {  
              !isModalVisible && <div className="ui huge text loader">Loading</div>
            }
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default App;
